var d = Object.defineProperty;
var h = (n, e, t) => e in n ? d(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var a = (n, e, t) => (h(n, typeof e != "symbol" ? e + "" : e, t), t);
import { isEmpty as w } from "./index33.js";
import { isNill as r } from "./index36.js";
import { isNumber as l } from "./index37.js";
class g {
  constructor() {
    a(this, "isMobile", !1);
    a(this, "os", {
      name: "Unknown",
      version: null
    });
    a(this, "browser", {
      name: "Unknown",
      version: null
    });
    this.detectClient(), this.is = this.is.bind(this);
  }
  detectClient() {
    const e = this.getUserAgent();
    if (w(e))
      return;
    const { os: t, osVersion: i } = this.detectOS(e), { browser: s, browserVersion: o } = this.detectBrowser(e);
    this.isMobile = this.detectMobile(), this.os = {
      name: t,
      version: i
    }, this.browser = {
      name: s,
      version: o
    };
  }
  get info() {
    return {
      isMobile: this.isMobile,
      os: { ...this.os },
      browser: { ...this.browser }
    };
  }
  is({
    type: e,
    osName: t,
    osVersion: i,
    browserName: s,
    browserVersion: o
  }) {
    return this.isType(e) && this.isOS(t, i) && this.isBrowser(s, o);
  }
  isType(e) {
    return r(e) ? !0 : e === "mobile" ? this.isMobile : !this.isMobile;
  }
  isOS(e, t) {
    return r(e) ? r(t) : this.os.name === e && (r(t) || this.versionsMatch(t, this.os.version));
  }
  isBrowser(e, t) {
    return r(e) ? r(t) : this.browser.name === e && (r(t) || this.versionsMatch(t, this.browser.version));
  }
  versionsMatch(e, t) {
    if (r(t))
      return !1;
    const i = parseFloat(t);
    if (!l(i))
      return !1;
    const s = e.charAt(0), o = e.charAt(1);
    if ([">", "<", "="].includes(s)) {
      const m = o.match(/[0-9]/) ? e.slice(1) : e.slice(2), c = parseFloat(m);
      if (!l(c))
        return !1;
      switch (s) {
        case ">":
          return o === "=" ? i >= c : i > c;
        case "<":
          return o === "=" ? i <= c : i < c;
        case "=":
          return i === c;
      }
    } else if (s.match(/[0-9]/))
      return parseFloat(e) === i;
    return !1;
  }
  detectMobile() {
    const e = this.getUserAgent();
    return !!(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      e
    ) || // eslint-disable-next-line no-useless-escape
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      e.slice(0, 4)
    ));
  }
  getUserAgent() {
    return typeof navigator > "u" ? "" : navigator.userAgent || // eslint-disable-next-line @typescript-eslint/no-deprecated
    navigator.vendor || // @ts-expect-error window.opera does not exist in window object
    window.opera || "";
  }
  detectOS(e) {
    const t = e.toLowerCase();
    if (/iphone|ipad|ipod/.test(t)) {
      const i = e.match(/OS\s+(\d+[_\d]*)\s+like Mac OS X/i) ?? e.match(/CPU (?:iPhone|iPad) OS\s+(\d+[_\d]*)\s+like Mac OS X/i);
      return {
        os: "iOS",
        osVersion: i ? i[1].replace(/_/g, ".") : null
      };
    }
    if (/android/.test(t)) {
      const i = e.match(/Android\s([\d\.]+)/);
      return {
        os: "Android",
        osVersion: i ? i[1] : null
      };
    }
    if (/windows nt/i.test(e)) {
      const i = e.match(/Windows NT ([\d\.]+)/i);
      return {
        os: "Windows",
        osVersion: i ? i[1] : null
      };
    }
    if (/macintosh|mac os x/i.test(e)) {
      const i = e.match(/Mac OS X ([\d_\.]+)/i);
      return {
        os: "macOS",
        osVersion: i ? i[1].replace(/_/g, ".") : null
      };
    }
    return /linux/i.test(e) ? { os: "Linux", osVersion: null } : { os: "Unknown", osVersion: null };
  }
  detectBrowser(e) {
    if (/edg\//i.test(e)) {
      const t = e.match(/Edg\/([\d\.]+)/);
      return { browser: "Edge", browserVersion: t ? t[1] : null };
    }
    if (/edge\//i.test(e)) {
      const t = e.match(/Edge\/([\d\.]+)/);
      return { browser: "Edge", browserVersion: t ? t[1] : null };
    }
    if (/msie\s|trident\//i.test(e)) {
      const t = e.match(/(MSIE\s|rv:)([\d\.]+)/i);
      return { browser: "IE", browserVersion: t ? t[2] : null };
    }
    if (/chrome|crios/i.test(e) && !/edg\//i.test(e) && !/opr\//i.test(e)) {
      const t = e.match(/(Chrome|CriOS)\/([\d\.]+)/);
      return { browser: "Chrome", browserVersion: t ? t[2] : null };
    }
    if (/firefox|fxios/i.test(e)) {
      const t = e.match(/(Firefox|FxiOS)\/([\d\.]+)/);
      return { browser: "Firefox", browserVersion: t ? t[2] : null };
    }
    if (/opr\//i.test(e)) {
      const t = e.match(/OPR\/([\d\.]+)/);
      return { browser: "Opera", browserVersion: t ? t[1] : null };
    }
    if (/safari/i.test(e) && !/chrome|crios|opr\//i.test(e)) {
      const t = e.match(/Version\/([\d\.]+)/);
      return { browser: "Safari", browserVersion: t ? t[1] : null };
    }
    return { browser: "Unknown", browserVersion: null };
  }
}
export {
  g as ClientRuntime
};
